/* eslint-disable no-underscore-dangle,no-param-reassign */

export default {
  install(Vue) {
    Vue.mixin({
      computed: {
        $config() {
          return this.$store.getters.getConfig;
        },
      },
    });
  },
};
